import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelDirective } from '../label/label.directive';

@NgModule({
  declarations: [LabelDirective],
  imports: [CommonModule],
  exports: [LabelDirective],
})
export class LabelModule {}
